/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Brand } from './Brand';
import {
    BrandFromJSON,
    BrandFromJSONTyped,
    BrandToJSON,
} from './Brand';
import type { CoordinateSystem } from './CoordinateSystem';
import {
    CoordinateSystemFromJSON,
    CoordinateSystemFromJSONTyped,
    CoordinateSystemToJSON,
} from './CoordinateSystem';
import type { DeviceInterfaceType } from './DeviceInterfaceType';
import {
    DeviceInterfaceTypeFromJSON,
    DeviceInterfaceTypeFromJSONTyped,
    DeviceInterfaceTypeToJSON,
} from './DeviceInterfaceType';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { QaEquipmentStateOfUse } from './QaEquipmentStateOfUse';
import {
    QaEquipmentStateOfUseFromJSON,
    QaEquipmentStateOfUseFromJSONTyped,
    QaEquipmentStateOfUseToJSON,
} from './QaEquipmentStateOfUse';
import type { QaEquipmentSubCategory } from './QaEquipmentSubCategory';
import {
    QaEquipmentSubCategoryFromJSON,
    QaEquipmentSubCategoryFromJSONTyped,
    QaEquipmentSubCategoryToJSON,
} from './QaEquipmentSubCategory';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { SingleDetectorConnectorType } from './SingleDetectorConnectorType';
import {
    SingleDetectorConnectorTypeFromJSON,
    SingleDetectorConnectorTypeFromJSONTyped,
    SingleDetectorConnectorTypeToJSON,
} from './SingleDetectorConnectorType';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { WithSerialNumber } from './WithSerialNumber';
import {
    WithSerialNumberFromJSON,
    WithSerialNumberFromJSONTyped,
    WithSerialNumberToJSON,
} from './WithSerialNumber';

/**
 * 
 * @export
 * @interface PtwQaEquipmentWithSerialNumberDto
 */
export interface PtwQaEquipmentWithSerialNumberDto {
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {number}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    masterDeviceId?: string | null;
    /**
     * 
     * @type {WithSerialNumber}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    withSerialNumber?: WithSerialNumber;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    typeNumber?: string | null;
    /**
     * 
     * @type {Brand}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    brand1?: Brand;
    /**
     * 
     * @type {SingleDetectorConnectorType}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    singleDetectorConnectorType?: SingleDetectorConnectorType;
    /**
     * 
     * @type {DeviceInterfaceType}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    deviceInterfaceType?: DeviceInterfaceType;
    /**
     * 
     * @type {QaEquipmentSubCategory}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    subCategory: QaEquipmentSubCategory;
    /**
     * 
     * @type {CoordinateSystem}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    coordinateSystem?: CoordinateSystem;
    /**
     * 
     * @type {QaEquipmentStateOfUse}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    state?: QaEquipmentStateOfUse;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    isRegistrable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithSerialNumberDto
     */
    $type?: PtwQaEquipmentWithSerialNumberDtoTypeEnum;
}


/**
 * @export
 */
export const PtwQaEquipmentWithSerialNumberDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoPtwQaEquipmentWithSerialNumberDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.PtwQaEquipmentWithSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type PtwQaEquipmentWithSerialNumberDtoTypeEnum = typeof PtwQaEquipmentWithSerialNumberDtoTypeEnum[keyof typeof PtwQaEquipmentWithSerialNumberDtoTypeEnum];


/**
 * Check if a given object implements the PtwQaEquipmentWithSerialNumberDto interface.
 */
export function instanceOfPtwQaEquipmentWithSerialNumberDto(value?: unknown): value is PtwQaEquipmentWithSerialNumberDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PtwQaEquipmentWithSerialNumberDtoTypeEnum)[0];
}

export function PtwQaEquipmentWithSerialNumberDtoFromJSON(json: any): PtwQaEquipmentWithSerialNumberDto {
    return PtwQaEquipmentWithSerialNumberDtoFromJSONTyped(json, false);
}

export function PtwQaEquipmentWithSerialNumberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PtwQaEquipmentWithSerialNumberDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': !exists(json, 'possibleActions') ? undefined : (json['possibleActions'] === null ? null : (json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': !exists(json, 'creatorUser') ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': !exists(json, 'editingUser') ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': !exists(json, 'editingTime') ? undefined : json['editingTime'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': !exists(json, 'isReferenced') ? undefined : json['isReferenced'],
        'isReferencedBy': !exists(json, 'isReferencedBy') ? undefined : (json['isReferencedBy'] === null ? null : (json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'deleterUserId': !exists(json, 'deleterUserId') ? undefined : json['deleterUserId'],
        'deletionTime': !exists(json, 'deletionTime') ? undefined : json['deletionTime'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'name': json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'typeSpecification': !exists(json, 'typeSpecification') ? undefined : json['typeSpecification'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
        'masterDeviceId': !exists(json, 'masterDeviceId') ? undefined : json['masterDeviceId'],
        'withSerialNumber': !exists(json, 'withSerialNumber') ? undefined : WithSerialNumberFromJSON(json['withSerialNumber']),
        'typeNumber': !exists(json, 'typeNumber') ? undefined : json['typeNumber'],
        'brand1': !exists(json, 'brand1') ? undefined : BrandFromJSON(json['brand1']),
        'singleDetectorConnectorType': !exists(json, 'singleDetectorConnectorType') ? undefined : SingleDetectorConnectorTypeFromJSON(json['singleDetectorConnectorType']),
        'deviceInterfaceType': !exists(json, 'deviceInterfaceType') ? undefined : DeviceInterfaceTypeFromJSON(json['deviceInterfaceType']),
        'subCategory': QaEquipmentSubCategoryFromJSON(json['subCategory']),
        'coordinateSystem': !exists(json, 'coordinateSystem') ? undefined : CoordinateSystemFromJSON(json['coordinateSystem']),
        'state': !exists(json, 'state') ? undefined : QaEquipmentStateOfUseFromJSON(json['state']),
        'isRegistrable': !exists(json, 'isRegistrable') ? undefined : json['isRegistrable'],
        'serialNumber': json['serialNumber'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function PtwQaEquipmentWithSerialNumberDtoToJSON(value?: PtwQaEquipmentWithSerialNumberDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'commentCount': value.commentCount,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'lastComment': value.lastComment,
        'isAvailable': value.isAvailable,
        'origin': EntityOriginToJSON(value.origin),
        'creatorUser': UserCatalogDtoToJSON(value.creatorUser),
        'lastModifierUser': UserCatalogDtoToJSON(value.lastModifierUser),
        'editingUser': UserCatalogDtoToJSON(value.editingUser),
        'editingTime': value.editingTime,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value.isReferenced,
        'isReferencedBy': value.isReferencedBy === undefined ? undefined : (value.isReferencedBy === null ? null : (value.isReferencedBy as Array<any>).map(ReferencingObjectDtoToJSON)),
        'name': value.name,
        'iuid': value.iuid,
        'description': value.description,
        'typeSpecification': value.typeSpecification,
        'category': RtSystemCategoryToJSON(value.category),
        'manufacturer': RtSystemManufacturerToJSON(value.manufacturer),
        'model': value.model,
        'subModel': value.subModel,
        'imageId': value.imageId,
        'isArchived': value.isArchived,
        'masterDeviceId': value.masterDeviceId,
        'withSerialNumber': WithSerialNumberToJSON(value.withSerialNumber),
        'typeNumber': value.typeNumber,
        'brand1': BrandToJSON(value.brand1),
        'singleDetectorConnectorType': SingleDetectorConnectorTypeToJSON(value.singleDetectorConnectorType),
        'deviceInterfaceType': DeviceInterfaceTypeToJSON(value.deviceInterfaceType),
        'subCategory': QaEquipmentSubCategoryToJSON(value.subCategory),
        'coordinateSystem': CoordinateSystemToJSON(value.coordinateSystem),
        'state': QaEquipmentStateOfUseToJSON(value.state),
        'isRegistrable': value.isRegistrable,
        'serialNumber': value.serialNumber,
        '$type': value.$type,
    });
}

